/*eslint-disable*/
import Axios from 'axios'
import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import APP_CONSTANT from "../../config/constants";

import DeleteModal from '../../components/modals/deleteModal'
import cogoToast from 'cogo-toast';

function BillActionButton(props) {
const [openBox, setopenBox] = useState(false)

let handleDelete = () => {
let payload = {
customerNo: localStorage.getItem("customerNo"),
userId: localStorage.getItem("userId"),
};
Axios.delete(
`${APP_CONSTANT.BASE_URL}purchase/debit-note/delete/${props.data.debitNoteId}`,
{
data: payload,
headers: {
"Content-Type": "application/json;charset=UTF-8",
"Access-Control-Allow-Origin": "*",
Authorization: localStorage.getItem("apiToken"),
},
}
)
.then((res) => {
cogoToast.success(
res.data.message
);
setTimeout(() => {
window.location.reload();
}, 2000);
})
.catch((err) => {
cogoToast.error(
"Error while deleting ",
);
});
}

let handleOpenDelete = (e) => {
setopenBox(true)
}

let handleCloseDelete = () => {
setopenBox(false)
}

return (
<>
{/* <Button onClick={handleView} basic size="mini" type="button" icon> <Icon name="eye" color="blue" /></Button> */}
{/* <Button disabled={props.data.status === "Pending" ? false : true} onClick={handleEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button> */}
<Button onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
<DeleteModal open={openBox} onClose={handleCloseDelete} handleDelete={handleDelete} isLoading={props.data.isLoading} /> 
</>
) 
}

export default BillActionButton

